import AttachmentBlock from "./AttachmentBlock.vue";

bootVue(".vue-attachment-block", AttachmentBlock);